import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import UserPersonaPicker from './UserPersonaPicker';
import { updateUserProfile } from '../api';

const PersonaRequiredOverlay = ({ showNotification, onComplete }) => {
  const [userPersonas, setUserPersonas] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (userPersonas.length === 0) {
      showNotification('Please select at least one business persona', 'error');
      return;
    }

    setIsSaving(true);
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        showNotification('Please log in again to continue.', 'error');
        return;
      }

      await updateUserProfile({ userPersonas }, token);
      showNotification('Business persona saved!', 'success');
      onComplete();
    } catch (error) {
      console.error('Error saving required persona:', error);
      showNotification(
        error.response?.data?.message || 'Failed to save business persona. Please try again.',
        'error'
      );
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-black/75 backdrop-blur-sm p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="persona-required-title"
    >
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-2xl p-6 sm:p-8 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-center mb-5">
          <div className="fd-brand-mark w-16 h-16 rounded-2xl">
            <img src="/logo.png?v=20260711" alt="Fashdeck" />
          </div>
        </div>

        <h2
          id="persona-required-title"
          className="text-xl sm:text-2xl font-bold text-gray-900 text-center mb-2"
        >
          Tell us about your business
        </h2>
        <p className="text-sm sm:text-base text-gray-600 text-center mb-6">
          Select at least one persona that describes your role in the fashion industry. This helps us personalize your experience.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Business Persona <span className="text-red-500">*</span>
            </label>
            <p className="text-xs text-gray-500 mb-3">Select all that apply</p>
            <UserPersonaPicker value={userPersonas} onChange={setUserPersonas} />
          </div>

          <button
            type="submit"
            disabled={isSaving || userPersonas.length === 0}
            className="w-full py-3 px-4 bg-[#5424e4] text-white rounded-xl font-semibold text-sm sm:text-base hover:bg-[#3d18b8] transition-all disabled:opacity-50 disabled:cursor-not-allowed shadow-lg"
          >
            {isSaving ? (
              <Loader2 size={20} className="animate-spin mx-auto" />
            ) : (
              'Continue to Fashdeck'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PersonaRequiredOverlay;
